import createAppStore from "./store";

const store = createAppStore();

export default store;
